import {getUserConfig} from "@utility/utils";

const initialState = {
    list: [],
    total: 0,
    loading: false,
    searching: false,
    submitting: false,
    searchParams: {
        description: "",
        operatorName: "",
        time: "",
        page: 1,
        count: 30,
        refresh: false,
        ...getUserConfig("config")
    }
}

const config = (state = initialState, action) => {
    switch (action.type) {
        case 'RECHARGE_CONFIG':
            return {
                ...state,
                ...action.payload
            }
        case 'RECHARGE_CONFIG_INIT':
            return {
                ...initialState,
                searchParams: {
                    ...initialState.searchParams, ...getUserConfig("config")
                },
            }
        default:
            return {...state};
    }
}

export default config
